import { connect } from 'react-redux';
import React, { Component } from 'react';
import actions from '../actions';
import heap from '../modules/heap';

import CreateAccountHeader from '../containers/CreateAccountHeader/CreateAccountHeader.jsx';
import CreateAccount from '../containers/CreateAccount/CreateAccount';
import Footer from '../components/Footer/Footer';
import GetTheApp from '../containers/GetTheApp/GetTheApp';
import Hero from '../components/Hero/Hero';
import Modal from '../components/Modal/Modal';
import PolicyDetails from '../containers/PolicyDetails/PolicyDetails';
import Login from '../containers/Login/Login.jsx';
import Logo from '../components/Logo/Logo';
import SetUpBilling from '../containers/SetUpBilling/SetUpBilling';
import SignYourForms from '../containers/SignYourForms/SignYourForms';
import StickyHeader from '../components/StickyHeader/StickyHeader';
import WatchYourMail from '../containers/WatchYourMail/WatchYourMail';
import WhatsHappening from '../containers/WhatsHappening/WhatsHappening';
import YourInformation from '../containers/YourInformation/YourInformation';

import { manageMyAccount } from '../settings/links.json';

import RebublicLogo from '../assets/images/republic-logo.png';

import IntroTemplate from '../templates/Intro';

export class Republic extends Component {
    headerButtonClick() {
        window.open(
            this.props.app.deploy.env ? manageMyAccount[this.props.app.deploy.env] : '',
            '_blank'
        );
    }

    requestCustomerDetails() {
        this.props.requestCustomerDetails(
            {
                lastName: this.props.customer.lastName,
                accessCode: this.props.customer.accessCode
            },
            {
                accessToken: this.props.customer.apigee.access_token,
                jwtToken: this.props.customer.apigee.jwtToken,
                env: this.props.app.deploy.env
            }
        );
    }

    componentDidMount() {
        setTimeout(
            c => {
                if (!c.props.customer.isAuthenticated) {
                    heap.track('customerPortal', { isAuthenticated: false });
                }
            },
            3000,
            this
        );
    }

    componentDidUpdate() {
        if (
            this.props.customer.isValid &&
            this.props.customer.isAuthenticated &&
            !this.props.details.customerData &&
            !this.props.details.isLoading &&
            !this.props.details.hasError
        ) {
            this.requestCustomerDetails();
        }

        if (this.props.customer.isValid && this.props.customer.isAuthenticated) {
            try {
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                });
            } catch (err) {
                console.log('unable to scroll window');
            }
        }

        if (this.props.customer.isAuthenticated) {
            heap.track('customerPortal', { isAuthenticated: true });
        }
    }

    render() {
        return (
            <IntroTemplate
                hasError={this.props.details.hasError}
                header={
                    <StickyHeader>
                        <Logo
                            secondaryLogoUrl={RebublicLogo}
                            type="cobranded"
                            alt="Republic Logo"
                            datacy="republic-logo"
                        />
                        {this.props.customer.isAuthenticated ? <CreateAccountHeader /> : <Login />}
                        <Modal
                            isShown={
                                !this.props.customer.hasError &&
                                this.props.customer.isValid &&
                                !this.props.customer.isAuthenticated
                            }
                            canBeClosed
                            type="security"
                        />
                    </StickyHeader>
                }
                footer={<Footer />}>
                <Hero
                    subject="In partnership with"
                    priorCarrier="Republic Insurance"
                    text="Welcome to Safeco Insurance"
                />
                <YourInformation />
                <PolicyDetails />
                <WhatsHappening
                    priorCarrier="Republic"
                    lineOfBusiness="the personal lines insurance market"
                    publicityUrl="https://ir.amtrustfinancial.com/news-releases/news-release-details/amtrust-enters-agreement-safeco-insurance-transfer-renewal/"
                />
                <WatchYourMail priorCarrier="Republic" />
                <SignYourForms />
                <SetUpBilling />
                <CreateAccount deploy={this.props.app.deploy} />
                <GetTheApp />
            </IntroTemplate>
        );
    }
}

export function mapStoreToProps(store) {
    return {
        customer: store.customer,
        details: store.details,
        app: store.app
    };
}

export function mapDispatchToProps(dispatch) {
    return {
        requestCustomerDetails: (data, tokens) =>
            dispatch(actions.details.requestCustomerDetails({ tokens, data }))
    };
}

export default connect(
    mapStoreToProps,
    mapDispatchToProps
)(Republic);



// WEBPACK FOOTER //
// ./src/pages/Republic.jsx